var _path, _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTauri(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 2500,
    viewBox: "-7.01114223 -.48904824 219.24490765 231.9000649",
    width: 2434,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m143.1 84a22 22 0 1 1 -44 0 22 22 0 0 1 44 0z",
    fill: "#ffc131"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 84.1,
    cy: 147,
    fill: "#24c8db",
    r: 22,
    transform: "matrix(-1 0 0 -1 168.2 294)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m166.7 154.5a84 84 0 0 1 -29 11.8 59 59 0 0 0 2.9-26.6 59 59 0 1 0 -67.4-90.1 98 98 0 0 0 -32.2 9.4 84 84 0 1 1 125.7 95.5zm-124.7-80.2 20.6 2.5a59 59 0 0 1 2.6-11.7 84 84 0 0 0 -23.2 9.2z",
    fill: "#ffc131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.4 76.5a84 84 0 0 1 29.2-11.9 58.9 58.9 0 0 0 -3.3 26.7 59 59 0 1 0 67.7 90 98 98 0 0 0 32.2-9.3 84 84 0 1 1 -125.8-95.5zm124.7 80.2-.4.2z",
    fill: "#24c8db"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTauri);
export default __webpack_public_path__ + "static/media/tauri.aa6488c443f786817fea18ffac8a72ac.svg";
export { ForwardRef as ReactComponent };